import * as React from 'react';
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
export const Screen1 = ({ free }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={`${screen1.container} ${main.bg}`}>
          <div className={screen1.info}>
            <h1>Английская лексика для&nbsp;<span>IT</span></h1>
            <p className={screen1.desc}>Базовая английская лексика для работы в IT для начинающих</p>
            <div className={screen1.btnBlock}>
              <p>
                Стоимость:
                <span className={screen1.oldPrice}>10&nbsp;000&nbsp;₽</span>
                { !free && <span className={screen1.price}>7&nbsp;900&nbsp;₽</span> }
              </p>
              <a href="#widget" className={screen1.btn}>Купить</a>
            </div>
            <p className={screen1.fit}>Подходит для людей с начальным уровнем английского языка</p>
          </div>
          <img src="https://fs.advance.ru/landing-pages/online/eng_for_it/screen1.svg" alt=""/>
        </div>
      </div>
    </section>
  );
};
